import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const BreadCrumb = () => {
  const location = useLocation();
  const urlSearchParams = new URLSearchParams(location.search);
  const sheetName = urlSearchParams.get("name");

  // Format sheet names properly
  const sheetDisplayNames = {
    striver: "Striver's SDE Sheet",
    lovebabbar: "Love Babbar 450",
    fraz: "Fraz's Sheet",
  };

  const breadcrumbNameMap = {
    "/problems": "My Problems",
    "/dsasheet": sheetName ? sheetDisplayNames[sheetName] : "DSA Sheets",
    "/settings": "Settings",
    "/account": "Account Settings",
    "/login": "Login",
    "/register": "Register",
    "/forgetpassword": "Forgot Password",
    "/reset": "Reset Password",
    "/contact": "Contact Support",
    "/notes": "My Notes",
    "/images": "Image Gallery",
  };

  const pathSnippets = location.pathname.split("/").filter((i) => i);

  // If we are on the absolute home page, we don't need a breadcrumb
  if (pathSnippets.length === 0) return null;

  return (
    <nav className="flex mb-6" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2 text-sm font-medium text-slate-500">
        
        {/* Home Icon */}
        <li>
          <Link 
            to="/" 
            className="flex items-center p-1.5 rounded-md hover:bg-slate-100 hover:text-blue-600 transition-colors"
            title="Home"
          >
            <Home className="w-4 h-4" />
            <span className="sr-only">Home</span>
          </Link>
        </li>

        {/* Dynamic Path Snippets */}
        {pathSnippets.map((snippet, index) => {
          const url = `/${pathSnippets.slice(0, index + 1).join("/")}`;
          const isLast = index === pathSnippets.length - 1;
          const name = breadcrumbNameMap[url] || snippet.charAt(0).toUpperCase() + snippet.slice(1);

          return (
            <li key={url} className="flex items-center space-x-2">
              <ChevronRight className="w-4 h-4 text-slate-400 shrink-0" />
              {isLast ? (
                <span 
                  className="text-slate-800 font-semibold cursor-default" 
                  aria-current="page"
                >
                  {name}
                </span>
              ) : (
                <Link 
                  to={url} 
                  className="hover:text-blue-600 transition-colors"
                >
                  {name}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadCrumb;